import type { ReactNode } from 'react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Breadcrumb, Space } from 'antd';
import styles from './index.less';
import { useLocation } from 'umi';
import type { IRoute } from '@umijs/renderer-react';
import cx from 'classnames';
import { ReactComponent as BreadHome } from '@/static/images/bread-home.svg';

import { pathToRegexp } from 'path-to-regexp';
import { useRequest } from '@@/plugin-request/request';
import { getCardCampInfo } from '@/utils/requests/camp/cardCamp';

type TBreadsProps = {
  route: IRoute;
};

const Breads: React.FC<TBreadsProps> = ({ route }) => {
  const location = useLocation();

  const pathname = location.pathname;
  const [activeItem, setActiveItem] = useState<ReactNode | undefined>(undefined);

  const findRouteByPathname = useCallback((routesArray: IRoute[], result: IRoute[] = []) => {
    for (let i = 0; i < routesArray.length; i++) {
      const routeItem = routesArray[i];
      if (routeItem.routes) {
        findRouteByPathname(routeItem.routes, result);
      } else {
        result.push(routeItem);
      }
    }
    return result.filter((resultItem) => resultItem.path !== '/');
  }, []);
  const data = useMemo(() => {
    return findRouteByPathname(route.routes as IRoute[]);
  }, [findRouteByPathname, route]);

  const { run: getCardCampInfoRun } = useRequest(
    (campId) => {
      return getCardCampInfo(campId);
    },
    {
      manual: true,
    },
  );

  useEffect(() => {
    //if (['/', '/case/', '/company/'].includes(pathname)) {
    //  setBgColor('#fff');
    //} else {
    //  setBgColor('#f7f9fc');
    //}

    const item = data.find((dataItem) => {
      const re = pathToRegexp(dataItem.path!);
      if (re.test(pathname)) {
        return dataItem;
      }
    });
    if (item) {
      if (item.path === '/v2/console/campsetings/:id') {
        // 获取打卡营名称
        const campId = pathname.replace('/v2/console/campsetings/', '');
        getCardCampInfoRun(campId).then((r) => {
          setActiveItem(
            <>
              <Breadcrumb.Item
                onClick={() => {
                  window.location.href = `/v2/console/campsetings`;
                }}
              >
                打卡营管理
              </Breadcrumb.Item>
              <Breadcrumb.Item>{r.name}</Breadcrumb.Item>
            </>,
          );
        });
      } else if (item.breadName) {
        setActiveItem(<Breadcrumb.Item>{item.breadName}</Breadcrumb.Item>);
      } else {
        setActiveItem(undefined);
      }
    } else {
      setActiveItem(undefined);
    }
  }, [pathname]);

  return (
    <div className={cx(styles.breads_wrapper, !activeItem && styles.empty)}>
      {activeItem && (
        <div className={styles.breads_inner}>
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => {
                window.location.href = `${process.env.HOME_URL}/internal`;
              }}
            >
              <Space size={4} className={styles.home_icon_wrapper}>
                <div className={styles.home_icon}>
                  <BreadHome />
                </div>
                <span>帆软内部服务</span>
              </Space>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => {
                window.location.href = `/v2/console/campsetings`;
              }}
            >
              学习管理后台
            </Breadcrumb.Item>
            {activeItem}
          </Breadcrumb>
        </div>
      )}
    </div>
  );
};
export default Breads;
